import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { getPostById, updatePost } from "../../services/postServices";

const EditPost = () => {
  const { id } = useParams();

  const [postData, setPostData] = useState({
    title: "",
    content: "",
    status: false, // false = draft, true = published
    category: false, // false = tailing, true = painting
  });
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const fetchPost = useCallback(async () => {
    try {
      const data = await getPostById(id);
      setPostData({
        title: data.title,
        content: data.content,
        status: data.status,
        category: data.category,
      });
      if (data.image1) setImages([data.image1]);
    } catch (err) {
      console.error("Failed to fetch post: ", err);
    }
  }, [id]);

  useEffect(() => {
    fetchPost();
  }, [fetchPost]);

  const handleFileChange = (e) => {
    const fileArray = Array.from(e.target.files);
    setImages(fileArray);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("title", postData.title);
      formData.append("content", postData.content);
      formData.append("status", postData.status ? "publish" : "draft");
      formData.append("category", postData.category ? "painting" : "tailing");

      images.forEach((image) => {
        formData.append("images", image);
      });

      await updatePost(id, formData);
      setIsSubmitted(true);
      setImages([]);

      setTimeout(() => setIsSubmitted(false), 5000);
    } catch (err) {
      console.error("Update failed: ", err);
      setIsSubmitted(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="container my-5">
      <div className="card">
        <div className="card-header">
          <h3>Edit Post</h3>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            {/* Title */}
            <div className="mb-3">
              <label htmlFor="postTitle" className="form-label">
                Title
              </label>
              <input
                type="text"
                id="postTitle"
                className="form-control"
                value={postData.title}
                onChange={(e) =>
                  setPostData({ ...postData, title: e.target.value })
                }
                placeholder="Add the title here..."
                required
              />
            </div>

            {/* Images */}
            <div className="mb-3">
              <label htmlFor="postImages" className="form-label">
                Upload Images
              </label>
              <input
                type="file"
                id="postImages"
                className="form-control"
                accept="image/*"
                multiple
                onChange={handleFileChange}
              />
            </div>

            {/* Content */}
            <div className="mb-3">
              <label htmlFor="postContent" className="form-label">
                Content
              </label>
              <textarea
                id="postContent"
                className="form-control"
                rows="10"
                value={postData.content}
                onChange={(e) =>
                  setPostData({ ...postData, content: e.target.value })
                }
              />
            </div>

            {/* Category */}
            <div className="mb-3">
              <label htmlFor="postCategory" className="form-label">
                Category
              </label>
              <select
                id="postCategory"
                className="form-select"
                value={postData.category}
                onChange={(e) =>
                  setPostData({
                    ...postData,
                    category: e.target.value,
                  })
                }
              >
                <option value="">Select category</option>
                <option value="painting">Painting</option>
                <option value="tailing">Tailing</option>
              </select>
            </div>

            {/* Status */}
            <div className="form-check mb-3">
              <input
                type="checkbox"
                id="postStatus"
                className="form-check-input"
                checked={postData.status}
                onChange={(e) =>
                  setPostData({
                    ...postData,
                    status: e.target.checked,
                  })
                }
              />
              <label htmlFor="postStatus" className="form-check-label">
                {postData.status ? "Published" : "Draft"}
              </label>
            </div>

            <div className="text-end">
              <button
                type="submit"
                className="btn btn-success"
                disabled={isLoading}
              >
                {isLoading ? "Updating..." : "Update Post"}
              </button>

              {isSubmitted && (
                <div
                  className={`alert mt-3 ${
                    postData.status ? "alert-success" : "alert-info"
                  }`}
                  role="alert"
                >
                  ✅ {postData.status ? "Post published" : "Draft saved"}!
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default EditPost;
